import { render, staticRenderFns } from "./CheckoffAdvice.vue?vue&type=template&id=1bd676e8"
import script from "./CheckoffAdvice.vue?vue&type=script&lang=js"
export * from "./CheckoffAdvice.vue?vue&type=script&lang=js"
import style0 from "./CheckoffAdvice.vue?vue&type=style&index=0&id=1bd676e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports